import Cookies from 'js-cookie';
import apiService from '../services/apiService';
import { toast } from 'react-toastify';

let previousContent = '';
let editorInstance = null;
let isRestoring = false;

export const deleteImageFromServer = async (imageUrl) => {
  try {
    const mediaUrl = process.env.REACT_APP_MEDIA_URL || '';
    if (!imageUrl.startsWith(mediaUrl)) {
      return;
    }
    await apiService.get(`deleteMedia?imageurl=${encodeURIComponent(imageUrl)}`);
    toast.success('Image deleted successfully');
  } catch (error) {
    console.error('Failed to delete image:', error);
  }
};

const extractImages = (content) => {
  const parser = new DOMParser();
  const doc = parser.parseFromString(content, 'text/html');
  const images = doc.querySelectorAll('img');
  return Array.from(images).map(img => img.getAttribute('src')).filter(Boolean);
};

export const getJoditConfig = () => ({
  readonly: false,
  height: 400,
  toolbarAdaptive: false,
  uploader: {
    insertImageAsBase64URI: false,
    url: `${process.env.REACT_APP_API_URL}uploadMedia`,
    headers: {
      'Authorization': `Bearer ${Cookies.get('token')}`
    },
    format: 'json',
    prepareData: function (formData) {
      const file = formData.get('files[0]');
      if (file) {
        formData.delete('files[0]');
        formData.append('image', file);
      }
      return formData;
    },
    isSuccess: function (resp) {
      return resp && resp.status && resp.data && resp.data.image;
    },
    getMessage: function (resp) {
      return resp.message || 'Upload failed';
    },
    process: function (resp) {
      const mediaUrl = process.env.REACT_APP_MEDIA_URL || '';
      return {
        files: [mediaUrl + resp.data.image],
        path: '',
        baseurl: '',
        error: 0,
        msg: resp.message || ''
      };
    },
    defaultHandlerSuccess: function (data) {
      if (data.files && data.files[0]) {
        this.selection.insertImage(data.files[0]);
      }
    },
    error: function (e) {
      toast.error('Image upload failed');
    }
  },
  disablePlugins: 'video,file,audio,speech-recognize',
  controls: {
    paragraph: {
      list: {
        p: 'Paragraph',
        h1: 'Heading 1',
        h2: 'Heading 2',
        h3: 'Heading 3',
        h4: 'Heading 4',
        h5: 'Heading 5',
        h6: 'Heading 6'
      }
    },
    font: {
      list: {
        'Arial': 'Arial',
        'Arial Black': 'Arial Black',
        'Brush Script MT': 'Brush Script MT',
        'Comic Sans MS': 'Comic Sans MS',
        'Courier New': 'Courier New',
        'Georgia': 'Georgia',
        'Helvetica': 'Helvetica',
        'Impact': 'Impact',
        'Lucida Console': 'Lucida Console',
        'Lucida Sans Unicode': 'Lucida Sans Unicode',
        'Palatino Linotype': 'Palatino Linotype',
        'Tahoma': 'Tahoma',
        'Times New Roman': 'Times New Roman',
        'Trebuchet MS': 'Trebuchet MS',
        'Verdana': 'Verdana'
      }
    }
  },
  events: {
    afterInit: function () {
      editorInstance = this;
      previousContent = this.value;
    },
    change: function (newValue) {
      if (isRestoring) {
        isRestoring = false;
        return;
      }

      const prevImages = extractImages(previousContent);
      const currImages = extractImages(newValue);
      const mediaUrl = process.env.REACT_APP_MEDIA_URL || '';
      
      const deletedImages = prevImages.filter(img => !currImages.includes(img) && img.startsWith(mediaUrl));
      
      if (deletedImages.length > 0) {
        const shouldDelete = window.confirm('Do you want to delete removed image(s) from server?');
        
        if (shouldDelete) {
          deletedImages.forEach(img => deleteImageFromServer(img));
          previousContent = newValue;
        } else {
          isRestoring = true;
          setTimeout(() => {
            if (editorInstance) {
              editorInstance.value = previousContent;
            }
          }, 0);
        }
      } else {
        previousContent = newValue;
      }
    }
  }
});
